// noinspection JSUnusedLocalSymbols

import Axios from "axios";
import {clearFeedbacksByName, clearInputsByName, getInputsByNameV2} from "../forms";
import handleAjaxError from "../handleAjaxError";
import {interceptValidationErrors, noValidationErrorsLeft} from "./validationErrors/utils";


class Form {
	/** @var {BaseForm.FormConfig} */
	config;

	/**
	 * @param {BaseForm.FormConfig} config
	 */
	constructor(config) {
		this.config = config;
		/** @type {import('../forms/validationErrors/utils').ValidationFilter[]} */
		this.validationErrorsFilters = [];
	}

	getValues() {
		return getInputsByNameV2(this.config.formElement, this.config.fields);
	};

	clearFeedbacks() {
		return clearFeedbacksByName(this.config.formElement);
	};

	clearInputs() {
		return clearInputsByName(this.config.formElement, this.config.fields)
	};

	getSubmitUrl() {
		return this.config.formElement.querySelector('input[name="submit_route"]').value;
	};

	submit() {
		this.clearFeedbacks();
		const formData = this.getValues();

		if (formData === undefined) {
			// End early, something must have gone wrong when
			// retrieving form data, this is a special scenario
			return new Promise((resolve, reject) => {
				reject('Local Validation Error');
			})
		}

		return Axios.post(this.getSubmitUrl(), this.getValues())
			.then(response => {
				const data = response.data;

				// noinspection JSUnresolvedReference
				if (data.update_route) {
					// Update submit route on form
					this.config.formElement.querySelector('input[name="submit_route"]').value = data.update_route;
				}

				if (this.config.onSuccess) {
					this.config.onSuccess(data);
				}

				return response;
			})
			.catch(error => {
				// We may need to intercept validation errors and handle them
				// ourselves before letting handleAjaxError receive them.
				// We can use this.validationErrorFilters to add filters to handle them.
				let interceptedValidationErrors = false;

				// If we have filters, attempt to intercept validation errors
				if (this.validationErrorsFilters.length > 0) {
					interceptedValidationErrors = interceptValidationErrors(error, this.validationErrorsFilters);
				}

				// If we didnt intercept anything or there were errors lefts...
				if (interceptedValidationErrors === false || noValidationErrorsLeft(error) === false) {
					///... default error handler
					handleAjaxError(error, this.config.formElement)
				}

				// Keep error going
				throw error;
			});
	};
}

export {Form}
